export const DG_ANNOTATION_PREFIX = 'deepgaming.eu/'

export const DG_ANNOTATIONS = {
  tier: 'deepgaming.eu/tier',
  businessOwner: 'deepgaming.eu/business-owner',
  supportSlack: 'deepgaming.eu/support-slack',
  escalation: 'deepgaming.eu/escalation',
  dataClassification: 'deepgaming.eu/data-classification',
  regulated: 'deepgaming.eu/regulated',
  partnerIntegrations: 'deepgaming.eu/partner-integrations',
  sloAvailability: 'deepgaming.eu/slo-availability',
  sloLatencyP95Ms: 'deepgaming.eu/slo-latency-p95-ms',
  costCenter: 'deepgaming.eu/cost-center',
  role: 'deepgaming.eu/role',
  lead: 'deepgaming.eu/lead',
  todo: 'deepgaming.eu/todo',
  ownerDefaulted: 'deepgaming.eu/owner-defaulted',
  environments: 'deepgaming.eu/environments',
  consulService: 'deepgaming.eu/consul-service',
  operationsFiles: 'deepgaming.eu/operations-files',
  descriptorFiles: 'deepgaming.eu/descriptor-files',
  descriptorWarnings: 'deepgaming.eu/descriptor-warnings',
  observedHosts: 'deepgaming.eu/observed-hosts',
  vaultSecrets: 'deepgaming.eu/vault-secrets',
} as const

export const TIERS = ['tier-1', 'tier-2', 'tier-3'] as const
export type Tier = (typeof TIERS)[number]

export const DATA_CLASSIFICATIONS = [
  'public',
  'internal',
  'pii',
  'financial',
] as const
export type DataClassification = (typeof DATA_CLASSIFICATIONS)[number]

export const ROLES = {
  ceo: 'CEO',
  cto: 'CTO',
  'head-of-engineering': 'Head of Engineering',
  'engineering-manager': 'Engineering Manager',
  'tech-lead': 'Tech Lead',
  'backend-developer': 'Backend Developer',
  'frontend-developer': 'Frontend Developer',
  'devops-sre': 'DevOps / SRE',
  'product-owner': 'Product Owner',
  'qa-engineer': 'QA Engineer',
  'lead-designer': 'Lead Designer',
  designer: 'Designer',
  'head-of-compliance': 'Head of Compliance',
  'account-manager': 'Account Manager',
  'business-owner': 'Business Owner',
  finance: 'Finance',
} as const
export type Role = keyof typeof ROLES

export function roleTitle(role: string | undefined): string | undefined {
  if (!role) {
    return undefined
  }
  return (ROLES as Record<string, string>)[role] ?? role
}

export const CORPORATE_KINDS = ['component', 'system', 'resource', 'api']
